import React from 'react'
import { SVGIconProps } from '../types'
const SvgPublish = ({ size = 16, ...props }: SVGIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="currentColor"
    {...props}
  >
    <path fill="none" d="M0 0h24v24H0z" />
    <path d="M5 4v2h14V4zm0 10h4v6h6v-6h4l-7-7z" />
  </svg>
)
export default SvgPublish
